<template>
  <div class="">Please wait...</div>
</template>

<script>
import { mapActions } from 'vuex';
import { appCallbackRoute } from '@/api/workflow';
export default {
  name: 'SSOCallback',
  beforeMount() {
    this.introspect()
      .then(() => {
        appCallbackRoute().then(route => {
          this.$router.push({ name: route });
        });
      })
      .catch((error) => {
        this.$router.push({ name: '500' });
      });
  },
  methods: {
    ...mapActions(['introspect'])
  }
};
</script>
<style></style>
